var $export = require('./_export');
var $task = require('./_task');
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});



//////////////////
// WEBPACK FOOTER
// /Users/m802941/.nvm/versions/node/v10.0.0/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/web.immediate.js
// module id = 385
// module chunks = 9